<template>
    <div class="bl-toc">
        <div class="pane-header">
                    <h2>Table of contents</h2>
                    <font-awesome-icon :icon="['fas', 'times']" size="sm" @click="closeIt"/>
        </div>
        <div class="pane-content" v-if="getAllByLaws && getAllByLaws.count > 0" ref="contentList">
            <div v-for="part in getAllByLaws.parts" :key="part.id">
                <div class="part-title mt-2" @click="loadPart($event, part.id)"><b>{{part.title}}</b></div>
                <div class="part-body indent d-none">
                    <div v-for="content in part.children" :key="content.id">
                        <div class="title"  @click="setActive($event, content)" data-level="1">  
                            <font-awesome-icon icon="caret-right" class="plus"/>
                            <font-awesome-icon icon="caret-down" class="minus d-none"/>                         
                            {{content.version}} {{content.title}}
                        </div>
                        <div class="indent d-none">
                            <div v-for="subcontent in content.subDocuments" :key="subcontent.id" >
                                <div class="title" @click="setActive($event, subcontent)" data-level="2">
                                  <font-awesome-icon icon="caret-right" class="plus" :style="{visibility: hasTitledContent(subcontent) ? 'visible' : 'hidden'}"/>
                                  <font-awesome-icon icon="caret-down" class="minus d-none" :style="{visibility: hasTitledContent(subcontent) ? 'visible' : 'hidden'}"/>  
                                    {{subcontent.version}} {{subcontent.title}}
                                </div>
                                <div class="indent d-none">
                                    <div v-for="chidlren in subcontent.subDocuments" :key="chidlren.id" >
                                        <div class="title ml-3" @click="setActive($event, chidlren)" data-level="3" v-if="chidlren.title">
                                          {{chidlren.version}} {{chidlren.title}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>    
            </div>
         
          <div class="mb-2 mt-3">
            <div class="card-body text-center" >               
               <hr/>
            </div>
          </div>
        </div>
    </div>
</template>

<script>
import closeIcon from "@/components/Svg/CloseIcon";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "tableofcontent",
  components: { closeIcon},
  data(){
    return{
      contentList:null,
      showPartChildren: false
    }
  },
  computed: {
    ...mapGetters("loader",["getRequestLoadStatus"]),
    ...mapGetters("viewer", ["getServiceStatus","getAllByLaws"]),
    
  },
  methods:{
    ...mapActions("viewer", ["fetchPusblishedContentByPart"]),   
     hasTitledContent: function(content){
      return content.subDocuments != null && content.subDocuments.length > 0 && content.subDocuments.filter(x=>x.title != null).length > 0;
    },
    loadPart: function(event, id){
      let { target } = event; 
      this.fetchPusblishedContentByPart(id);
      if(!target.classList.contains("part-title")){
        target = target.parentNode;
      }
      if(target.nextElementSibling?.classList.contains("d-none")){
        target.nextElementSibling?.classList.remove("d-none");
      } else {
        target.nextElementSibling?.classList.add("d-none");
      }
    },
    referToBylaw: function(content){
      if(!content) return;
      if(content.version != null){
        this.$router.push(`/searchbyversion/${content.version}`);
      } else {
        this.$router.push(`/definitions/${content.title}`);
      }
    },
    closeIt: function(){
      this.$emit("close");
    },
    setActive: function(event, content){
      let { target } = event;   
      if(!target.classList?.contains('title')){
          target = target.parentNode;
          if(!target.classList?.contains('title')){
            target = target.parentNode;
          }
      }
      
      if(!target.classList?.contains('active')){
        var allActivetitle = this.$refs.contentList.querySelectorAll(".title.active");
      
        allActivetitle.forEach(node => {         
          node.classList?.remove("active");
        });

        target.children[0]?.classList.add("d-none");
        target.children[1]?.classList.remove("d-none");
        
        target.classList?.add("active");
        target.nextElementSibling?.classList.remove("d-none");
        this.referToBylaw(content);
      } else {
        target.children[0]?.classList.remove("d-none");
        target.children[1]?.classList.add("d-none");
        
        target.classList?.remove("active");
        target.nextElementSibling?.classList.add("d-none");
        this.referToBylaw(content);

      }
    }
  },
   watch: {    
    getAllByLaws: function (newvalue) {
      if(newvalue){
        this.contentList = newvalue;
      }
    }
  }
};
</script>